import { buildSelector } from '@/shared/lib/store';

export type Mode = 'comparison' | 'aggregation';

export const [usePatternLabMode] = buildSelector<Mode, []>(
    (state: AppStateSchema) => state.patternLab?.mode ?? 'comparison',
);
